import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';
import { removeAppStatusAction, appStatusesSelector } from 'domain/env';

import { AppStatusBarRoot } from 'components/AppStatusBar/StyledComponents';
import Alert from '@mui/material/Alert';

const AppStatusBar = () => {
  const dispatch = useDispatch();
  const appStatuses = useSelector(appStatusesSelector);

  const onClose = useCallback(
    (appStatusId) => {
      dispatch(removeAppStatusAction(appStatusId));
    },
    [dispatch],
  );

  return (
    <AppStatusBarRoot>
      {appStatuses.map((appStatus) => (
        <Alert
          key={appStatus.id}
          severity="error"
          sx={{ borderColor: 'error.main', borderStyle: 'solid', borderWidth: 1 }}
          onClose={() => onClose(appStatus.id)}
        >
          <FormattedMessage {...appStatus} />
        </Alert>
      ))}
    </AppStatusBarRoot>
  );
};

export default AppStatusBar;
